import { render, staticRenderFns } from "./ClientesVapp.vue?vue&type=template&id=47a21456&"
import script from "./ClientesVapp.vue?vue&type=script&lang=js&"
export * from "./ClientesVapp.vue?vue&type=script&lang=js&"
import style0 from "./ClientesVapp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports